import { GET_ERROR_NOTIFICATION_CONTENT } from "../../../../enums/MyDivision/Delegation/AuthorityDelegation.types";

export const getErrorNotificationContentAction = (data) => {
    return {
        type: GET_ERROR_NOTIFICATION_CONTENT,
        payload: data,
    };
};